import React from 'react'
import { SourcingCompany } from './graphql/generated/graphql-types'

type ContextType = {
  sourcingCompany: SourcingCompany
  firstName: string
  lastName: string
  fullName: string
  email: string
  returnUrl: string | null
  isAuthenticated: boolean
  preRegistrationToken: string | null
  contactIdFromCookie?: number
  anonymousUserIdentifier?: string
}

const value: ContextType = {
  firstName: '',
  lastName: '',
  fullName: '',
  email: '',
  sourcingCompany: SourcingCompany.None,
  returnUrl: '',
  isAuthenticated: false,
  preRegistrationToken: null,
}

const AppContext = React.createContext(value)

export default AppContext
